import React from 'react';
import {Field} from 'formik';
import {ClickableFormOption} from '../../ClickableFormStructure';

export function FormikSingleCheckBox({name, label, value, disabled}) {
    return (
        <ClickableFormOption disabled={disabled} checkbox label={label} htmlFor={'checkbox' + name + value}>
            {name && (
                <Field disabled={disabled} name={name} id={'checkbox' + name + value} value={value} type="checkbox" />
            )}
        </ClickableFormOption>
    );
}
